import { environmentCommons } from "./environment.commons";

export const environment = {
  ...environmentCommons,
  production: true,
  firebase: {
    apiKey: 'AIzaSyDMHpij_o6yiZ4dU8bC1LjHsuiTMf7l1zs',
    authDomain: 'pe-gcp-customercare-02.firebaseapp.com',
    databaseURL: 'https://pe-gcp-customercare-02-default-rtdb.firebaseio.com',
    projectId: 'pe-gcp-customercare-02',
    storageBucket: 'pe-gcp-customercare-02.appspot.com',
    messagingSenderId: '52415902569',
    appId: '1:52415902569:web:bf00b2c694e4dd2f2743f8',
    measurementId: 'G-SWH3GRWV39',
  },
  authApiBaseUrl: 'https://api.cc-irdigital.pe/public/cc-auth-svc',
  comunicationsApiBaseUrl: 'https://api.cc-irdigital.pe/irma/cc-irma-admin',
  orchestratorApiBaseUrl: 'https://api.cc-irdigital.pe/irma/cc-irma-orchestrator',
  productCode: 'IRMA',
  xRequestedBy: 'irma-web',
};
